import { PlusIcon } from 'lucide-react'
import { Drawer } from '@/components/shared/Drawer'
import { assetPath } from '@/utils/assetPath'

interface CreateSelectionBottomSheetProps {
    open: boolean
    onClose: () => void
    onOptionSelect: (option: 'collection' | 'look' | 'product') => void
}

export const CreateSelectionBottomSheet = ({
    open,
    onClose,
    onOptionSelect,
}: CreateSelectionBottomSheetProps) => {
    const createOptions = [
        {
            icon: assetPath('icons/collection-solid.svg'),
            label: 'Collection',
            description: 'Create a new collection',
            onClick: () => onOptionSelect('collection'),
        },
        // {
        //   icon: assetPath('icons/look-solid.svg'),
        //   label: "Look",
        //   description: "Create a new look",
        //   onClick: () => onOptionSelect("look"),
        // },
        {
            icon: assetPath('icons/product-solid.svg'),
            label: 'Product',
            description: 'Create a new product',
            onClick: () => onOptionSelect('product'),
        },
    ]

    return (
        <Drawer
            triggerContent={null}
            open={open}
            onOpenChange={onClose}
            contentClassName="bg-white z-[9999]"
        >
            {/* Add padding to account for bottom navigation */}
            {createOptions.map((option) => (
                <button
                    key={option.label}
                    className="border-black-6 mx-auto flex w-full max-w-md items-center justify-between border-b px-2 py-4 text-left"
                    onClick={option.onClick}
                >
                    <div className="flex items-center gap-3">
                        <img src={option.icon} alt={option.label} />
                        <div className="flex flex-col">
                            <h2 className="text-14 font-semibold">
                                {option.label}
                            </h2>
                            <p className="text-13 text-black-48">
                                {option.description}
                            </p>
                        </div>
                    </div>
                    <PlusIcon className="mr-2 h-6 w-6" />
                </button>
            ))}
        </Drawer>
    )
}
